import { render, staticRenderFns } from "./gameMaster.vue?vue&type=template&id=3638c49c&scoped=true&"
import script from "./gameMaster.vue?vue&type=script&lang=js&"
export * from "./gameMaster.vue?vue&type=script&lang=js&"
import style0 from "./gameMaster.vue?vue&type=style&index=0&id=3638c49c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3638c49c",
  null
  
)

export default component.exports